import React, { createContext, useContext } from 'react'

const NavigationContext = createContext()

export const NavigationProvider = ({ children, navigationFunctions }) => {
    return (
        <NavigationContext.Provider value={navigationFunctions}>
            {children}
        </NavigationContext.Provider>
    )
}

export const useNavigation = () => {
    const context = useContext(NavigationContext)
    if (!context) {
        console.warn('useNavigation must be used within a NavigationProvider')
        return {
            navigateToCase: () => console.warn('Navigation not available'),
            navigateToCaseQueue: () => console.warn('Navigation not available'),
            navigateBack: () => console.warn('Navigation not available'),
        }
    }
    return context
}
